import * as React from 'react';
import b_ from 'b_';
import cn from 'classnames';

const b = b_.with('crypto-icon');

export const symbols: { [key: string]: string | React.ReactElement<any> } = {
  USD: '$',
  RUB: '₽',
  EUR: '€',
  BTC: <i className={cn(b(), b('BTC'))} />,
  ETH: <i className={cn(b(), b('ETH'))} />,
  UTT: <i className={cn(b(), b('UTT'))} />,
};
